namespace Matrix.Data {
    export interface SecurityValueForm {
        SecurityId: Serenity.IntegerEditor;
        SourceCode: Serenity.StringEditor;
        InstanceCode: Serenity.StringEditor;
        AsAtDate: Serenity.DateEditor;
        PriceLocal: Serenity.DecimalEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityValueForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityValue';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityValueForm.init)  {
                SecurityValueForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(SecurityValueForm, [
                    'SecurityId', w0,
                    'SourceCode', w1,
                    'InstanceCode', w1,
                    'AsAtDate', w2,
                    'PriceLocal', w3,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
